import Vue from 'vue'
import FeatherIcon from '@/components/FeatherIcon.vue'
import GoogleMap from '@/components/GoogleMap.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('google-map', GoogleMap)
